import React from 'react';
import { Box } from '@mui/material';
import stripe from '../assets/stripe-checkout.png';
import { useNavigate } from 'react-router-dom';


const Stripecheckout = () => {

    const navigate = useNavigate();

    return (
        <>
            <Box
                sx={{ width: '100%' }}
                component="img"
                src={stripe}
                onClick={() => navigate('/order-placed')}
            />
        </>
    );
}

export default Stripecheckout;